<template>
    <div>
        <div class="c-banner-box">
            <img class="c-banner" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner.png" alt="">
            <div class="c-banner-cbox">
                <div class="c-banner-cboxbg">
                    <swiper class="swiper-no-swiping" ref="mySwiper" :options="swiperOptions">
                        <swiper-slide>
                            <div>
                                <div  class="c-banner-cinfo">
                                    <div class="c-banner-cImgbg">
                                        <img class="c-banner-cImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-t3.png" alt="">
                                    </div>
                                    <div>数据平台业务</div>
                                    <div>咨询案例</div>
                                    <img class="hover-show" style="margin-top: 7px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-hover-a.png" alt="">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div>
                                <div  class="c-banner-cinfo">
                                    <div class="c-banner-cImgbg">
                                        <img class="c-banner-cImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-t4.png" alt="">
                                    </div>
                                    <div>促销活动业务</div>
                                    <div>咨询案例</div>
                                    <img class="hover-show" style="margin-top: 7px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-hover-a.png" alt="">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div>
                                <div  class="c-banner-cinfo">
                                    <div class="c-banner-cImgbg">
                                        <img class="c-banner-cImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-t5.png" alt="">
                                    </div>
                                    <div>会员通整合业务</div>
                                    <div>咨询案例</div>
                                    <img class="hover-show" style="margin-top: 7px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-hover-a.png" alt="">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div>
                                <div class="c-banner-cinfo">
                                    <div class="c-banner-cImgbg">
                                        <img class="c-banner-cImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-t1.png" alt="">
                                    </div>
                                    <div>移动订餐和派单</div>
                                    <div>系统案例</div>
                                    <img class="hover-show" style="margin-top: 7px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-hover-a.png" alt="">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div>
                                <div  class="c-banner-cinfo">
                                    <div class="c-banner-cImgbg">
                                        <img class="c-banner-cImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-t2.png" alt="">
                                    </div>
                                    <div>智能管理</div>
                                    <div>平台案例</div>
                                    <img class="hover-show" style="margin-top: 7px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-hover-a.png" alt="">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div>
                                <div  class="c-banner-cinfo">
                                    <div class="c-banner-cImgbg">
                                        <img class="c-banner-cImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-t6.png" alt="">
                                    </div>
                                    <div>双师教学管理</div>
                                    <div>平台案例</div>
                                    <img class="hover-show" style="margin-top: 7px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-hover-a.png" alt="">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div>
                                <div  class="c-banner-cinfo">
                                    <div class="c-banner-cImgbg">
                                        <img class="c-banner-cImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-t7.png" alt="">
                                    </div>
                                    <div>督学营销</div>
                                    <div>平台案例</div>
                                    <img class="hover-show" style="margin-top: 7px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-hover-a.png" alt="">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div>
                                <div  class="c-banner-cinfo">
                                    <div class="c-banner-cImgbg">
                                        <img class="c-banner-cImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-t8.png" alt="">
                                    </div>
                                    <div>智能教学</div>
                                    <div>系统案例</div>
                                    <img class="hover-show" style="margin-top: 7px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-hover-a.png" alt="">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div>
                                <div  class="c-banner-cinfo">
                                    <div class="c-banner-cImgbg">
                                        <img class="c-banner-cImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-t9.png" alt="">
                                    </div>
                                    <div>IT咨询案例</div>
                                    <img class="hover-show" style="margin-top: 7px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-hover-a.png" alt="">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div>
                                <div  class="c-banner-cinfo">
                                    <div class="c-banner-cImgbg">
                                        <img class="c-banner-cImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-t10.png" alt="">
                                    </div>
                                    <div>全渠道业务中台</div>
                                    <div>咨询案例</div>
                                    <img class="hover-show" style="margin-top: 7px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-hover-a.png" alt="">
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div>
                                <div  class="c-banner-cinfo">
                                    <div class="c-banner-cImgbg">
                                        <img class="c-banner-cImg" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-t11.png" alt="">
                                    </div>
                                    <div>测评系统</div>
                                    <div>（学前）案例</div>
                                    <img class="hover-show" style="margin-top: 7px;" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-banner-hover-a.png" alt="">
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-button-next"  @click="next(1)" slot="button-next"></div>
                    <div class="swiper-button-prev"  @click="prev(1)" slot="button-prev"></div>
                </div>
            </div>
        </div>
        <div class="company-honor">
            <div class="c-header">
                <div class="c-line"></div>
                <div>Case studies</div>
            </div>
            <div class="c-title">
                <div>合作<span style="color:rgba(88, 103, 116, 1);">案例</span><div class="c-title-line"></div></div>
            </div>
            <div class="c-title" style="margin-top: 43px;margin-bottom: 20px;">
                <div v-if="cindex == 0">某零售公司数据平台业务咨询</div>
                <div v-if="cindex == 1">某零售公司促销活动业务咨询</div>
                <div v-if="cindex == 2">某零售公司会员通整合业务咨询</div>
                <div v-if="cindex == 3">某餐饮集团移动订餐解决方案及派单系统</div>
                <div v-if="cindex == 4">某教育集团营运管理平台</div>
                <div v-if="cindex == 5">某教育机构双师教学管理平台</div>
                <div v-if="cindex == 6">某教育品牌课程 /作业打卡 + 营销</div>
                <div v-if="cindex == 7">某教育集团数字化教学</div>
                <div v-if="cindex == 8">某零售公司IT咨询</div>
                <div v-if="cindex == 9">某零售公司全渠道业务中台咨询</div>
                <div v-if="cindex == 10">某教育品牌测评系统（学前）</div>
            </div>
            <div class="c-title2" v-if="cindex == 0">以实现精准营销为目标，构建统一数据管理平台</div>
            <div class="c-title2" v-if="cindex == 1">面向全渠道的活动规则</div>
            <div class="c-title2" v-if="cindex == 2">打通会员、实现共赢</div>
            <div class="c-title2" v-if="cindex == 3">为多品牌打造全新的移动订餐平台及统一派单系统</div>
            <div class="c-title2" v-if="cindex == 4">构建一体化营运管理体系和管理平台，提高营运效率</div>
            <div class="c-title2" v-if="cindex == 5">构建一体化双师教学管理平台</div>
            <div class="c-title2" v-if="cindex == 6">构建基于微信生态的课程打卡体系和营销工具</div>
            <div class="c-title2" v-if="cindex == 7">构建课前、课中、课后一体化教学系统，提高教学质量和教学效率</div>
            <div class="c-title2" v-if="cindex == 8">对Digital业务进行梳理，并根据未来3-5年业务发展进行IT规划</div>
            <div class="c-title2" v-if="cindex == 9">构建符合DT时代更创新灵活的组织机制和业务机制</div>
            <div class="c-title2" v-if="cindex == 10">构建基于微信生态的课程打卡体系和营销工具</div>
            <div class="c-title3" style="margin-bottom: 25px;">背景</div>
            <div class="c-title4" v-if="cindex==0">行业竞争日益激烈，大数据浪潮形势迅猛，数字化产业飞速发展。公司需要建设一个能够整合内外部数据并有效分析客户行为特征的数据管理平台，精准分析市场动态，有效锁定目标营销客户人群，实现价值变现。</div>
            <div class="c-title4" v-if="cindex==1">随着中国业务的快速发展和新技术的应用，公司需要制定适应市场变化和多渠道的促销活动规则（包括线上与线下），以带来更多的流量。配合大数据分析，优化活动规则，做到精准营销。</div>
            <div class="c-title4" v-if="cindex==2">随着业务的快速发展和新技术的使用，公司与国内知名电商公司进行战略合作，实现会员打通，合作双赢。第三方电商平台作为线上销售渠道之一，实现会员互通后，将会给企业带来更多的会员流量。</div>
            <div class="c-title4" v-if="cindex==3">随着移动互联网的迅速发展，移动用户快速增长的同时，社交订餐文化也逐渐形成趋势，订餐移动化已迫在眉睫。品牌需要对未来精准营销，打造全新的移动订餐平台和统一的派单系统。</div>
            <div class="c-title4" v-if="cindex==4">随着公司业务的快速发展，企业营运成本快速上升，使用数字化技术来实现自动化处理流程、降低运营成本的需求已迫在眉睫，该数字化应用范围包括学生报名、学生缴费、合作校加盟、管理费、返点结算、权限管理、营运报表等。</div>
            <div class="c-title4" v-if="cindex==5">随着公司业务的创新，公司决定开展双师教学的新模式，需要建立统一的管理平台，包括加盟校的管理、课程管理、排班管理、排课管理（课表、老师、教室）、费用管理、报表统计等功能，迎合新模式下的业务需要。</div>
            <div class="c-title4" v-if="cindex==6">该公司是国内领先的教育品牌、内容提供商，并且拥有自己的直营校，随着公司业务和新技术的快速发展，公司决定采用数字化技术进行督学互动，在助力教师提高教学效率的同时，帮助学生提高学习成绩的，并达到营销引流的目的。</div>
            <div class="c-title4" v-if="cindex==7">随着业务的快速发展和新技术的使用，集团需要重新梳理和构建符合新技术时代的更创新灵活的数字化教学体系，贯穿课前、课中、课后各个环节，让老师专注于教学，提高教学质量及教学效率，用数据优化各个流程环节。</div>
            <div class="c-title4" v-if="cindex==8">随着中国业务的快速发展，公司制定了未来3-5年的业务规划。基于现有IT架构已无法快速适应业务的发展，根据未来业务发展，对现有业务，以及现有IT架构进行了梳理，制定应对未来业务发展的TO-BE架构已迫在眉捷。</div>
            <div class="c-title4" v-if="cindex==9">随着业务的快速发展和新技术的使用，公司需要制定适应市场变化的新业务机制。重新梳理和构建符合DT时代更创新灵活的中台业务机制，提炼各个业务条线的共同需求，并将其打造成组件化产品，然后以接口的形式提供给全渠道业务部门使用，使前台更加灵活敏捷。</div>
            <div class="c-title4" v-if="cindex==10">该教育品牌专注于学前教育，具有自己的品牌、教学体系、和优秀的口碑。根据业务的需要，在学生“入学”前以小游戏形式对其进行评测，系统会在测试完成后给出智能分析结果以及精准测评报告，报告可用于分享、传播，助力企业引流。</div>
            <div class="c-title3" style="margin-top: 80px;margin-bottom: 20px;">挑战</div>
            <div class="c-info-box" v-if="cindex==0">
                <div class="c-info">多种数据来源和原始基础数据质量不高</div>
                <div class="c-info">各业务需求逻辑复杂繁多</div>
                <div class="c-info">现有业务机制不合理</div>
                <div class="c-info-line">
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                </div>
            </div>
            <div class="c-info-box" v-if="cindex==1">
                <div class="c-info">目前没有营销活动机制</div>
                <div class="c-info">需要全渠道个性化营销</div>
                <div class="c-info">制定适合公司业态的活动规则</div>
                <div class="c-info-line">
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                </div>
            </div>
            <div class="c-info-box" v-if="cindex==2">
                <div class="c-info">业务复杂</div>
                <div class="c-info">集成复杂</div>
                <div class="c-info">涉及多个业务线及部门</div>
                <div class="c-info">维续良好的用户体验</div>
                <div class="c-info-line">
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                </div>
            </div>
            <div class="c-info-box" v-if="cindex==3">
                <div class="c-info">一品牌、多平台</div>
                <div class="c-info">极佳用户体验</div>
                <div class="c-info">自动化升级机制</div>
                <div class="c-info">高并发要求</div>
                <div class="c-info-line">
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                </div>
            </div>
            <div class="c-info-box" v-if="cindex==4">
                <div class="c-info">加盟校和直营校模式</div>
                <div class="c-info">多级管理</div>
                <div class="c-info">梳理整个营运业务流程，制定规范</div>
                <div class="c-info">帮助企业节约成本、提高效率</div>
                <div class="c-info-line">
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                </div>
            </div>
            <div class="c-info-box" v-if="cindex==5">
                <div class="c-info">加盟校模式</div>
                <div class="c-info">多级管理</div>
                <div class="c-info">灵活的排课管理</div>
                <div class="c-info">支持合作校的排班排课</div>
                <div class="c-info">支持合作校的双重身份</div>
                <div class="c-info-line">
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                </div>
            </div>
            <div class="c-info-box" v-if="cindex==6">
                <div class="c-info">建立智能督学系统（课程打卡）</div>
                <div class="c-info">建立数字化营销的体系</div>
                <div class="c-info">提高引流及转化</div>
                <div class="c-info">提高学生成绩及教学效率</div>
                <div class="c-info-line">
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                </div>
            </div>
            <div class="c-info-box" v-if="cindex==7">
                <div class="c-info">多个环节未数字化</div>
                <div class="c-info">涉及直营校与加盟校</div>
                <div class="c-info">涉及教学习惯的改变</div>
                <div class="c-info">流程不规范</div>
                <div class="c-info-line">
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                </div>
            </div>
            <div class="c-info-box" v-if="cindex==8">
                <div class="c-info">业务复杂</div>
                <div class="c-info">现有架构不合理</div>
                <div class="c-info">时间周期短</div>
                <div class="c-info">规划要求极高</div>
                <div class="c-info-line">
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                </div>
            </div>
            <div class="c-info-box" v-if="cindex==9">
                <div class="c-info">业务复杂，业务线多</div>
                <div class="c-info">现有业务机制不合理</div>
                <div class="c-info">涉及整个企业业务，跨多个知识领域</div>
                <div class="c-info">涉及组织机构的变化</div>
                <div class="c-info-line">
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                </div>
            </div>
            <div class="c-info-box" v-if="cindex==10">
                <div class="c-info">针对学前儿童，考虑合适的方式</div>
                <div class="c-info">简单、方便，极佳体验</div>
                <div class="c-info">精准的分析</div>
                <div class="c-info-line">
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                    <div class="c-info-d"></div>
                </div>
            </div>
            <div class="c-info-fiex" style="margin-top: 90px;">
                <div style="margin-right: 70px;">
                    <img class="c-crux" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-crux.png" alt="">
                </div>
                <div>
                    <div class="c-title3" style="margin-top: 80px;margin-bottom: 20px;">关键点</div>
                    <div class="c-info-box" v-if="cindex==0">
                        <div class="c-info">数据整合处理和数据加工处理</div>
                        <div class="c-info">梳理现有业务逻辑和维度</div>
                        <div class="c-info">提供多维分析工具，满足各部门不同粒度和维度分析需求 </div>
                        <div class="c-info">应用机器学习能力，提供更好的建模和预测</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==1">
                        <div class="c-info">全渠道</div>
                        <div class="c-info">业务规则&优化</div>
                        <div class="c-info">以消费者为中心</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==2">
                        <div class="c-info">合理的业务模型</div>
                        <div class="c-info">体验为中心</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==3">
                        <div class="c-info">极佳的用户体验</div>
                        <div class="c-info">支持大用户量并发</div>
                        <div class="c-info">稳定、可靠、可扩展的架构</div>
                        <div class="c-info">快速的更新模式</div>
                        <div class="c-info">快速适应业务发展</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==4">
                        <div class="c-info">涉及两种业务类型：直营和加盟</div>
                        <div class="c-info">卓越的用户体验</div>
                        <div class="c-info">提高教学效率，节约成本</div>
                        <div class="c-info">累计数据，统计分析</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==5">
                        <div class="c-info">加盟校模式，加盟校双重身份</div>
                        <div class="c-info">全流程的排课表、排教室（直播室、教室）、排老师（讲师、助教）</div>
                        <div class="c-info">在新模式下，提高教学效率</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==6">
                        <div class="c-info">基于微信生态的课程/作业打卡平台</div>
                        <div class="c-info">基于微信生态的营销工具</div>
                        <div class="c-info">极佳的用户体验</div>
                        <div class="c-info">线索管理、分析和转化</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==7">
                        <div class="c-info">涉及两种业务类型：直营和加盟</div>
                        <div class="c-info">极佳的用户体验</div>
                        <div class="c-info">能够提高教学效率，用数字化改进教学流程</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==8">
                        <div class="c-info">业务涉及多个部门，需要良好、有效的沟通</div>
                        <div class="c-info">业务复杂，并依赖国外业务</div>
                        <div class="c-info">TO-BE的业务模型</div>
                        <div class="c-info">TO-BE的IT架构模型</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==9">
                        <div class="c-info">业务涉及多个业务</div>
                        <div class="c-info">业务复杂，并依赖国外业务</div>
                        <div class="c-info">TO-BE的业务中台模型</div>
                        <div class="c-info">TO-BE的中台IT架构模型</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==10">
                        <div class="c-info">以小游戏的方式呈现题目，包括语音</div>
                        <div class="c-info">极佳的用户体验</div>
                        <div class="c-info">精准的测评</div>
                        <div class="c-info">基于微信生态进行分享传播</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                </div>
                <img class="c-down" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-down.png" alt="">
            </div>
            <div class="c-info-fiex" style="margin-top: 150px;">
                <div style="width: 500px;">
                    <div class="c-title3" style="margin-top: 80px;margin-bottom: 20px;">方案</div>
                    <div class="c-info-box" v-if="cindex==0">
                        <div class="c-info">传统业务基础，引入互联网能力</div>
                        <div class="c-info">涉及整个企业业务，跨多个知识领域</div>
                        <div class="c-info">适应组织机构的变化</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==1">
                        <div class="c-info">梳理现有业务</div>
                        <div class="c-info">制定适合全渠道的业务规则</div>
                        <div class="c-info">保持一致体验</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==2">
                        <div class="c-info">梳理现有业务条线</div>
                        <div class="c-info">分析在第三方平台的业务形态</div>
                        <div class="c-info">形成业务模型</div>
                        <div class="c-info">实现会员互认</div>
                        <div class="c-info">保持一致体验</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==3">
                        <div class="c-info">Hybrids开发模式</div>
                        <div class="c-info">以体验为中心</div>
                        <div class="c-info">灵活的更新升级模式</div>
                        <div class="c-info">统一内容管理平台，以及统一的派单管理系统（移动端及管理端）</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==4">
                        <div class="c-info">梳理现有业务情况</div>
                        <div class="c-info">根据未来业务发展规划，建立符合业务要求的数字化解决方案</div>
                        <div class="c-info">融合炯耀教育营运管理SaaS平台解决用户痛点</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==5">
                        <div class="c-info">梳理双师教学的业务需求</div>
                        <div class="c-info">根据未来业务发展规划，建立符合业务要求的数字化解决方案</div>
                        <div class="c-info">融合炯耀教育智能排课和营运管理产品解决用户痛点</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==6">
                        <div class="c-info">梳理业务需求，根据业务发展规划，建立符合业务要求的数字化解决方案</div>
                        <div class="c-info">融合炯耀教育知新打卡系统，以及炯耀智能营销最佳实践，建立灵活、高效的打卡+营销平台，解决客户痛点</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==7">
                        <div class="c-info">梳理现有业务情况</div>
                        <div class="c-info">根据未来业务发展规划，建立符合业务要求的数字化解决方案</div>
                        <div class="c-info">融合炯耀教育产品和最佳实践，解决客户痛点</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==8">
                        <div class="c-info">梳理现有业务流程</div>
                        <div class="c-info">根据未来业务发展规划，建立业务模型</div>
                        <div class="c-info">梳理现有IT架构</div>
                        <div class="c-info">根据业务发展规划，建立TO-BE IT架构</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==9">
                        <div class="c-info">梳理现有业务</div>
                        <div class="c-info">根据未来业务发展规划，建立适合全渠道的业务模型</div>
                        <div class="c-info">根据业务发展规划，建立TO-BE业务中台模型</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                    <div class="c-info-box" v-if="cindex==10">
                        <div class="c-info">梳理业务需求，根据业务发展规划，建立符合业务要求的数字化解决方案</div>
                        <div class="c-info">融合炯耀教育的最佳实践，提供适合幼儿的测评系统</div>
                        <div class="c-info-line">
                            <div class="c-info-d"></div>
                            <div class="c-info-d"></div>
                        </div>
                    </div>
                </div>
                <div style="margin-left: 190px;">
                    <img class="c-crux"  src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-programme.png" alt="">
                </div>
            </div>
            <div class="c-videobg">
                <img class="c-videobtn" src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-videobtn.png" alt="">
                <div class="mb">
                    <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/cooperation-lock.png" alt="">
                </div>
            </div>
<!--            <div class="c-article-box">
                <div class="c-article">
                    <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-article-t1.png" alt="">
                    <div class="c-article-date">2020-08-03</div>
                    <div class="c-article-cont">
                        公众号文章内容展示公众号文章内容展示公众号文章内容展示公众号文章内容展示公众号文章内容展示
                    </div>
                </div>
                <div class="c-article">
                    <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-article-t2.png" alt="">
                    <div class="c-article-date">2020-08-03</div>
                    <div class="c-article-cont">
                        公众号文章内容展示公众号文章内容展示公众号文章内容展示公众号文章内容展示公众号文章内容展示
                    </div>
                </div>
                <div class="c-article">
                    <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-article-t3.png" alt="">
                    <div class="c-article-date">2020-08-03</div>
                    <div class="c-article-cont">
                        公众号文章内容展示公众号文章内容展示公众号文章内容展示公众号文章内容展示公众号文章内容展示
                    </div>
                </div>
                <div class="c-article">
                    <img src="https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-article-t2.png" alt="">
                    <div class="c-article-date">2020-08-03</div>
                    <div class="c-article-cont">
                        公众号文章内容展示公众号文章内容展示公众号文章内容展示公众号文章内容展示公众号文章内容展示
                    </div>
                </div>
            </div>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "cooperation",
        data:vm=>{
            return{
                cindex:0,
                swiperOptions: {
                    pagination: {
                        el: '.swiper-pagination'
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    slidesPerView: 5,
                    spaceBetween: 0,
                    centeredSlides: true,
                    observer: true,
                    observeParents: true,
                    loop: true,
                    on:{
                        slideNextTransitionStart: function (e) {
                            // console.log(e.realIndex);
                            vm.cindex = e.realIndex
                        },
                        slidePrevTransitionStart: function (e) {
                            // console.log(e.realIndex);
                            vm.cindex = e.realIndex
                        },
                    }
                },
            }
        },
        methods:{
            tipvideo(){
                this.$message.warning("即将开放，敬请期待~")
            },
            prev() {
               this.swiper.slidePrev();
            },
            change(index){
                console.log(333333,index);
            },
            next() {
               this.swiper.slideNext();
            },
        },
        created() {
          var that = this;
            // console.log(43,that.$route.query.num);
            if(that.$route.query.num){
              setTimeout(()=>{
                  that.swiper.slideToLoop(Number(that.$route.query.num))
              },50)
          }
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.$swiper
            },
        },
    }
</script>

<style lang="less" scoped>
    .c-banner-box{
        margin-top: 7px;
        position: relative;
        margin-bottom: 100px;
        .c-banner-cbox{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 300px;
            background: rgba(220, 6, 22, .79);
            display: flex;
            justify-content: center;
            align-items: center;
            .c-banner-cboxbg{
                width: 1200px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                .c-banner-cinfo{
                    /*cursor: pointer;*/
                    width: 198px;
                    height: 223px;
                    background: #FFFFFF;
                    border: 1px solid #DCDCDC;
                    border-radius: 20px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    font-size: 20px;
                    z-index: 9;
                    transition: all .3s linear;
                    .c-banner-cImgbg{
                        width: 140px;
                        height: 140px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
                .swiper-button-next{
                    color: #fff;
                    position: absolute;
                    right: -40px;
                }
                .swiper-button-prev{
                    color: #fff;
                    position: absolute;
                    left: -80px;
                }
                /deep/ .swiper-wrapper{
                    display: flex;
                    align-items: center;
                    position: relative;
                }
                /deep/ .swiper-slide-active .c-banner-cinfo{
                    height: 255px;
                    background: #FFFFFF;
                    border: 5px solid #FF5251;
                    border-radius: 20px;
                }
                .hover-show{
                    display: none;
                }
                /deep/ .swiper-slide-active .hover-show{
                    display: block;
                }
            }
        }
        .c-banner{
            width: 100%;
        }
    }
    .company-honor{
        width: 1200px;
        margin: 0 auto;
        position: relative;
        .c-header{
            font-size: 18px;
            display: flex;
            align-items: center;
            position: relative;
            padding-left: 50px;
            margin-bottom: 24px;
            .c-line{
                width: 100px;
                height: 1px;
                background: #626262;
                position: absolute;
                left: -60px;
            }
        }
        .c-title{
            position: relative;
            display: flex;
            font-size: 34px;
            font-weight: bold;
            .c-title-line{
                width: 59px;
                height: 6px;
                background: #DC0616;
                position: absolute;
                left: 2px;
                bottom: 2px;
                z-index: -1;
            }
        }
        .c-title2{
            font-size: 20px;
            margin-bottom: 160px;
        }
        .c-title3{
            font-size: 20px;
            color: #AB0101;
            font-weight: bold;
        }
        .c-title4{
            font-size: 14px;
            position: relative;
            width: 800px;
        }
        .c-fiex{
            position: absolute;
            right: 0;
            top: -90px;
        }
        .c-info-box{
            padding-left: 20px;
            font-size: 14px;
            position: relative;
            .c-info{
                margin-bottom: 10px;
            }
            .c-info-line{
                width: 1px;
                height: 100%;
                background: #545454;
                position: absolute;
                left: 0;
                top: 0;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                .c-info-d{
                    width: 7px;
                    height: 7px;
                    background: #AC0202;
                    border-radius: 50%;
                }
            }

        }
        .c-info-fiex{
            display: flex;
            align-items: center;
            position: relative;
            .c-down{
                position: absolute;
                right: 0;
                bottom: -110px;
            }
        }
        .c-videobg{
            margin-top: 127px;
            margin-bottom: 27px;
            width: 1200px;
            height: 612px;
            background: url("https://jdc-prod.oss-cn-hangzhou.aliyuncs.com/unishining/image/c-videobg.png") no-repeat;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            .c-videobtn{
                cursor: pointer;
            }
            .mb{
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                background: rgba(0,0,0,.8);
            }
        }
        .c-article-box{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 60px;
            .c-article{
                width: 280px;
                .c-article-date{
                    font-size: 14px;
                    color: #959595;
                    margin: 10px 0;
                }
                .c-article-cont{
                    color: #333;
                    font-size: 14px;
                }
            }
        }
    }

</style>